module.exports = __webpack_public_path__ + "img/BD.f5965871.png";